import React from 'react';
import classes from "./UtilitiesSubtitle.module.css";

export default function UtilitiesSubtitle() {
    return (
        <div className={classes.UtilitiesSubtitle}>
            <div className={classes.title_text}>
                <h3>BIRDS COIN</h3>
            </div>
            <div className={classes.description}>
                <p>
                    is a platform for joint purchases <br />
                    that we implement. How it will work:
                </p>
                <div className={classes.frame}>
                    <svg width="244" height="14" viewBox="0 0 244 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12C79.5918 -0.937049 164.451 -1.33117 243.522 10.8736" stroke="#FFC700" strokeWidth="3" strokeMiterlimit="10" />
                    </svg>
                </div>
                <div className={classes.shape}>
                    <svg width="62" height="64" viewBox="0 0 62 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M43.3604 53.4405C33.1945 58.0202 20.4002 51.6261 14.7837 39.1588C9.16712 26.6915 12.8551 12.8721 23.0211 8.29229C33.187 3.71252 45.9812 10.1066 51.5978 22.574C57.2143 35.0413 53.5263 48.8607 43.3604 53.4405Z" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M23.021 8.29224L18.4071 10.3708C8.24023 14.951 4.55298 28.7695 10.1677 41.2327C15.7824 53.696 28.5754 60.0901 38.7408 55.5106L43.3562 53.4313" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M21.2827 12.4862C19.936 13.2824 17.9013 15.9631 16.7716 18.8768C15.5538 22.0176 15.0245 25.4669 15.2705 27.3221" stroke="white" strokeWidth="2.08865" strokeLinecap="round" />
                        <path d="M35.7077 18.8072L37.8691 29.8955" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M24.8768 22.3859L28.1546 31.4594" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M33.3919 36.0314C35.4804 38.511 38.3438 38.5461 41.2114 38.3421C38.81 39.766 36.8586 41.7459 35.5146 44.2407" stroke="white" strokeWidth="2.08865" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    )
}
